import { render, staticRenderFns } from "./ShowFollow.vue?vue&type=template&id=366d7a20&"
import script from "./ShowFollow.vue?vue&type=script&lang=js&"
export * from "./ShowFollow.vue?vue&type=script&lang=js&"
import style0 from "./ShowFollow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShowFollow.vue"
export default component.exports